const NotFound = () => {
    return (
        <div className="w-full h-96 flex flex-col gap-8 justify-center items-center">
            <h1 className="text-lg">Internet is Disconnencted</h1>
        </div>
    )
}

export default NotFound;